import React, { Dispatch } from "react";

import { StyledRow } from "../../../../../../../../../../components/common";

const Footer: React.FC<Footer.Props> = () => <StyledRow gap="24px"></StyledRow>;

declare namespace Footer {
	interface Value {
		active: boolean;
		default: boolean;
	}

	interface Props {
		value: Value;

		disabled: boolean;
		assignableTo?: "dispatcher" | "executor";

		onChange: Dispatch<Value>;
	}
}

export default Footer;
